// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import ReactDragListView from 'react-drag-listview/lib/index.js';

import {
    Table,
    Col,
    Row,
    UncontrolledTooltip,
} from "reactstrap"
import { IoIosAdd } from "react-icons/io";
import { GrDrag } from "react-icons/gr";


//import components
import Breadcrumbs from 'components/_Common/Breadcrumb';
import DeleteModal from "components/_Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";

// actions
import { deleteQuestionnaire, listMailBatch } from "store/actions";
import AddEditModal from "../AddEdit/MailSendModel";
import toastr from "toastr";
import MyPagination from "components/_Common/MyPagination";
import { withTranslation } from "react-i18next";
import { onSendBatchEmail } from "helpers/backend_api_helper";


const List = props => {
    //meta title
    document.title = `${props.t("Email")}  | ${props.t("Admin")}`;

    const { error, success, loading } = useSelector(state => ({
        loading: state.Email.loading,
        error: state.Email.error,
        success: state.Email.success,
    }));

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [modal, setModal] = useState(false);
    const [itemData, SetItemData] = useState();
    const [tableData, SetTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [filterData, setFilterData] = useState({
        "limit": 25,
        "page": currentPage,
        "search": ""
    });

    const toggle = () => {
        if (modal) {
            setModal(false);

        } else {
            setModal(true);
        }
    };


    //delete question
    const [deleteModal, setDeleteModal] = useState(false);
    const onClickDelete = (item) => {
        SetItemData(item)
        setDeleteModal(true);
    };
    const handleDeleteMailBatch = () => {
        dispatch(deleteQuestionnaire({ ids: [itemData?.id] }, (res) => {
            if (res?.status === 'success') {
                setDeleteModal(false);
                toastr.success(res?.message)
                fetchQuestionnaireList()
                setFilterData(prevFilterData => ({
                    ...prevFilterData,
                    randomEvent: Math.random()
                }));

            } else {
                toastr.error(res?.message)
            }
        }))
    };

    // edit 
    const handleQuestionClick = data => {
        SetItemData(data)
        toggle();
    };

    // list
    const fetchQuestionnaireList = (filterData) => {
        dispatch(listMailBatch(filterData, (res) => {
            if (res?.status === 'success') {
                SetTableData(res?.data)
                SetItemData({})
            }
        }))
    }
    useEffect(() => {
        fetchQuestionnaireList(filterData)
    }, [currentPage, filterData?.search, filterData?.limit, filterData?.question_type])

    // filter 
    const debounce = (func, delay) => {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    };

    // Function to handle search
    const handleSearch = debounce((searchTerm) => {
        setFilterData(prevFilterData => ({
            ...prevFilterData,
            search: searchTerm
        }));
    }, 500);

    const handleLimit = (val) => {
        setFilterData(prevFilterData => ({
            ...prevFilterData,
            limit: val
        }));
    }

    // delete selecetd
    const [deleteIds, setDeleteIds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const toggleSelectAll = () => {
        setSelectAll(!selectAll);
        const ids = selectAll ? [] : tableData?.batches?.map(item => item.id);
        setDeleteIds(ids || []);
    };

    const onChangeSelectDelete = (id) => {
        const updatedDeleteIds = deleteIds.includes(id)
            ? deleteIds.filter(deleteId => deleteId !== id)
            : [...deleteIds, id];
        setDeleteIds(updatedDeleteIds);
    }

    const onDeleteSelected = () => {
        toastr.error("work in progress")
        return
        dispatch(deleteQuestionnaire({ ids: [...deleteIds] }, (res) => {
            if (res?.status === 'success') {
                setDeleteModal(false);
                toastr.success(res?.message)
                fetchQuestionnaireList()
                setFilterData(prevFilterData => ({
                    ...prevFilterData,
                    randomEvent: Math.random()
                }));
                setDeleteIds([]);
                setSelectAll(false);

            } else {
                toastr.error(res?.message)
            }
        }))
    };
    const [mailData, setMailData] = useState(null)
    const sendMailWithType = async (id, type) => {
        setMailData({ id, type })
        try {
            const res = await onSendBatchEmail(id, type);
            if (res?.status == 'success') {
                toastr.success(res?.message);
                fetchQuestionnaireList(filterData)
                setMailData(null)

            } else {
                toastr.error(res?.message || "Server Error")
                setMailData(null)

            }
        } catch (error) {
            setMailData(null)
        }
    }

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteMailBatch}
                onCloseClick={() => setDeleteModal(false)}
                loading={loading}
                modalContent={props.t("Are you sure delete Schor ?")}
            />
            <AddEditModal
                modal={modal}
                toggle={toggle}
                itemData={itemData}
                fetchQuestionnaireListData={() => fetchQuestionnaireList(filterData)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title={props.t("Mail")} breadcrumbItem={props.t("Manage Email")} />

                    <Row>
                        <Col lg="12">
                            <Row className="mb-2 d-flex show-select show-select justify-spacebetween">
                                <Col md={1} className="me-4 space-marg-rem" >
                                    <select
                                        className="form-select custm-select"
                                        onChange={(e) => handleLimit(e.target.value)}
                                    >
                                        <option value="25">
                                            {props.t("Show")} 25
                                        </option>
                                        <option value="50">
                                            {props.t("Show")} 50
                                        </option>
                                        <option value="75">
                                            {props.t("Show")} 75
                                        </option>
                                        <option value="100">
                                            {props.t("Show")} 100
                                        </option>
                                    </select>
                                </Col>
                                <Col md={2} >
                                    <div className="search-box d-inline-block">
                                        <div className="position-relative">
                                            <label htmlFor="search-bar-0" className="search-label">
                                                <input
                                                    onChange={e => {
                                                        handleSearch(e.target.value);
                                                    }}
                                                    id="search-bar-0"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={props.t("Search") + "..."}
                                                />
                                            </label>
                                            <i className="bx bx-search-alt search-icon"></i>
                                        </div>
                                    </div>

                                </Col>
                                <Col md={4}></Col>

                                <Col md={4} className="text-end pe-0">

                                    <div className="custm-btns">
                                        {
                                            deleteIds?.length > 0 &&
                                            <button
                                                disabled={deleteIds?.length <= 0 ? true : false}
                                                className="btn btn-lg btn-soft-danger"
                                                onClick={onDeleteSelected}
                                                style={{ background: deleteIds?.length <= 0 ? "#82345573" : "", color: deleteIds?.length <= 0 ? "white" : "" }}
                                            >
                                                {props.t("Delete Selected")}

                                            </button>
                                        }

                                        {/* <button
                                            onClick={() => {
                                                setModal(true)
                                                SetItemData({})
                                            }}
                                            className="btn btn-primary"
                                        >
                                            {props.t("Send Mail")}
                                        </button> */}
                                        {/* <Link onClick={() => fetchQuestionList(filterData)} className="btn btn-light me-1"><i className="mdi mdi-refresh"></i></Link> */}
                                    </div>
                                </Col>
                            </Row>
                            <div className="table-responsive">
                                {
                                    loading ?
                                        <div className="loader d-flex justify-content-center align-items-center mt-5" >
                                            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                            {props.t("Loading")}
                                        </div>
                                        :
                                        <Table className="table mb-0 table-space">
                                            <thead>
                                                <tr>
                                                    {/* <th>
                                                        <label className="radio-check-label">
                                                                <input
                                                                    className="fill-checkbox"
                                                                    type="checkbox"
                                                                    checked={selectAll}
                                                                    onClick={toggleSelectAll}
                                                                    onChange={toggleSelectAll}
                                                                />
                                                                <span className="radio-check"></span>
                                                            </label> 
                                                        </th> */}
                                                    <th className="main-data-fix-width"> {props.t("Batch Name")}</th>
                                                    <th>{props.t("Invitation")}</th>
                                                    <th>{props.t("Reminder")}</th>
                                                    {/* <th>{props.t("Status")}</th> */}
                                                    <th style={{ textAlign: "center", paddingRight: "25px" }}>{props.t("Send Email")}</th>


                                                </tr>
                                            </thead>
                                            {
                                                tableData?.batches?.length <= 0
                                                    ?
                                                    <tr>
                                                        <td colSpan="5" className="text-center no-record-found">{props.t("No Record Found")}</td>
                                                    </tr>
                                                    :
                                                    <tbody>
                                                        {(tableData?.batches || []).map((item, index) => (
                                                            <tr key={index}>
                                                                {/* <td>
                                                                        <label className="radio-check-label">
                                                                            <input
                                                                                className="fill-checkbox"
                                                                                type="checkbox"
                                                                                onChange={toggleSelectAll}
                                                                                checked={deleteIds.includes(item.id)}
                                                                                onClick={() => onChangeSelectDelete(item.id)}
                                                                            />
                                                                            <span className="radio-check"></span>
                                                                        </label>   
                                                                    </td> */}
                                                                <td className="txt-manage">{item?.title}</td>
                                                                <td>
                                                                    <button className={item?.invitation === 'Y' ? "yes-btn" : "no-btn"}> {item?.invitation === 'Y' ? "Sent" : "Not Sent"}</button>

                                                                    {/* <label className="radio-check-label">
                                                                            <input
                                                                                className="fill-checkbox"
                                                                                type="checkbox"
                                                                                checked={item?.invitation == 'Y' ? true : false}
                                                                            />
                                                                            <span className="radio-check"></span>
                                                                        </label> */}
                                                                </td>
                                                                <td>
                                                                    <button className={item?.reminder === 'Y' ? "yes-btn" : "no-btn"}> {item?.reminder === 'Y' ? "Sent" : "Not Sent"}</button>
                                                                    {/* <label className="radio-check-label">
                                                                            <input
                                                                                className="fill-checkbox"
                                                                                type="checkbox"
                                                                                checked={item?.invitation == 'Y' ? true : false}
                                                                            />
                                                                            <span className="radio-check"></span>
                                                                        </label> */}
                                                                </td>
                                                                {/* <td><button className={item?.is_active === 'Y' ? "yes-btn" : "no-btn"}> {item?.is_active === 'Y' ? "Active" : "In-Active"}</button></td>  */}
                                                                <td className="space-invi-remind">
                                                                    <div style={{ textAlign: "center" }}>
                                                                        {
                                                                            mailData?.type == 'invitation' && mailData?.id == item?.id
                                                                                ?
                                                                                <button className="invitaion-btn" >{props.t("Sending")}...</button>
                                                                                :
                                                                                <button className="invitaion-btn" onClick={() => sendMailWithType(item?.id, 'invitation')}>{props.t("Invitation")}</button>
                                                                        }
                                                                        {
                                                                            mailData?.type == 'reminder' && mailData?.id == item?.id
                                                                                ?
                                                                                <button className="reminder-btn"  style={{ marginLeft: '5px' }} >{props.t("Sending")}...</button>
                                                                                :
                                                                                <button className="reminder-btn" onClick={() => sendMailWithType(item?.id, 'reminder')} style={{ marginLeft: '5px' }} >{props.t("Reminder")}</button>

                                                                        }
                                                                    </div>

                                                                </td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                            }

                                        </Table>
                                }
                            </div>
                            {
                                tableData?.records < filterData?.limit ?
                                    ""
                                    :
                                    <MyPagination
                                        filterData={filterData}
                                        recordsPerPage={filterData?.limit}
                                        totalRecords={tableData?.records}
                                        currentPage={currentPage}
                                        onPageChange={(pageNumber) => {
                                            setCurrentPage(pageNumber)
                                            setFilterData(prevFilterData => ({
                                                ...prevFilterData,
                                                page: pageNumber
                                            }));
                                        }}
                                    />
                            }
                        </Col>
                    </Row>
                </div>
            </div >
        </React.Fragment >
    );
}

List.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(List);
